import React from "react";
import "./Page8.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto8 from "../images/pagePhoto8.png";
//-----------------------------------------

function Page8() {
  return (
    <div className="page8_container">
      <div className="page8_bangla">
        প্রত্যেকটি Web App একটি বিশেষ বিক্রেতার জন্য তৈরী একটি E-Shop। নিদ্দিষ্ট
        কোনো বিক্রেতার জন্য তৈরী এই Web App টির মাধ্যমে যেকোনো ক্রেতা তার
        অর্ডার, কোনো নিদ্দিষ্ট বিক্রেতার কাছে E-Mail’এর মাধ্যমে পাঠাতে পারবেন
        এবং পরবর্তী পর্যায়ে বিক্রেতা এবং ক্রেতা ফোনের মাধ্যমে যোগাযোগ করে
        Payment এবং Delivery র ব্যবস্থা করতে পারবেন। এই E-Shop এর পরিষেবাটি ছোটো
        অথবা মাঝারি দোকান এবং দোকান না থাকা বিক্রেতার জন্য বিশেষ উপযুক্ত।
      </div>
      <div className="page8_english">
        Each Web-App is developed for a particular business owned by a
        particular Seller in the form of an E-Shop. Through our Web-App a
        Customer can place an order which is sent to a Seller by an E-Mail.
        After receiving such orders Seller and Customer can communicate over
        phone and arrange for delivery and payment. This E-Shop is appropriate
        for small and medium shops and also for Sellers without proper show-room
        or shop.
      </div>
      <div className="page8_banglaEnglish">
        আপনার E-Shop তৈরীর জন্য আপনাকে আমাদের কাছে কি কি Item পাঠাতে হবে –
        <br />
        What all items are required to be sent to us to create Your Own E-Shop -
      </div>
      <div className="page8_photo_div">
        <img className="page8_photo" src={pagePhoto8} alt="PagePhoto8 Logo" />
      </div>
      <div className="page8_bangla">
        আপনার প্রত্যেকটি প্রোডাক্ট'এর “Photo”, “Title”, “Details” এবং “Price”
        আমাদের E-Mail Address’এ পাঠান। মাত্র এই চারটি Item থেকেই আপনার
        প্রতিষ্ঠানের নামে নতুন E-Shop তৈরী হবে।
      </div>
      <div className="page8_english">
        Photo, Title, Details and Price of every item that you want to sell are
        to be sent to us by E-Mail. A new E-Shop can be developed for your
        business only with these four items.
      </div>
      {/*--------------go to page-8 (next page) starts-------------*/}
      <NavLink to="/contactus" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-8 (next page) ends-------------*/}
    </div>
  );
}

export default Page8;
